import { AxiosError } from 'axios';
import { getNotificationStyle } from '../common/notification';
import { IFileUpload } from '../model/CommonModel';
import { UploadFormData } from '../stores/common';
import AjexPortalService from './api';
import config from './config';

const tmsPricingService = process.env.REACT_APP_TMS_PRICING_SERVICE;

const agreementStationPricesMaster = config.get('agreementStationPricesMaster');
const agreementStationGroupPricesMaster = config.get('agreementStationGroupPricesMaster');
const agreementRateRangeMaster = config.get('agreementRateRangeMaster');
const agreementRateRangeStationMaster = config.get('agreementRateRangeStationMaster');
const bulk = config.get('bulk');
const upload = config.get('upload');
const product = config.get('product');
const productId = config.get('productId');

// ─── Master Station Prices (Manual Waybill Default Charges) ─────────────────

export const GetMasterStationListByProductService = async (productId: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreementStationPricesMaster}/${product}/${productId}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetMasterStationByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreementStationPricesMaster}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveMasterStationBulkService = async (data: { agreementStationsPriceList: any[] }, productId: number) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${agreementStationPricesMaster}/${bulk}/${productId}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateMasterStationService = async (data: any, id: number) => {
    try {
        return await AjexPortalService.put(`${tmsPricingService}${agreementStationPricesMaster}/${id}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DeleteMasterStationByIdService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${tmsPricingService}${agreementStationPricesMaster}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UploadMasterStationFileService = async (fileObject: Partial<IFileUpload>, productId: number) => {
    try {
        const { formData, configuration } = UploadFormData(fileObject);
        return await AjexPortalService.post(`${tmsPricingService}${agreementStationPricesMaster}/${upload}/${productId}`, formData, configuration);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

// ─── Master Station Group Prices (Manual Waybill Default Charges) ────────────

export const GetMasterStationGroupListByProductService = async (productId: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreementStationGroupPricesMaster}/${product}/${productId}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const GetMasterStationGroupByIdService = async (id: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreementStationGroupPricesMaster}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveMasterStationGroupBulkService = async (data: { agreementStationGroupPriceDtoList: any[] }, productId: number) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${agreementStationGroupPricesMaster}/${bulk}/${productId}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateMasterStationGroupService = async (data: any, id: number) => {
    try {
        return await AjexPortalService.put(`${tmsPricingService}${agreementStationGroupPricesMaster}/${id}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DeleteMasterStationGroupByIdService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${tmsPricingService}${agreementStationGroupPricesMaster}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

// ─── Station Group Additional Weight Charges (Manual Waybill Default Charges) ─

export const GetMasterRateRangeGroupListByProductService = async (productIdValue: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreementRateRangeMaster}/${productId}/${productIdValue}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveMasterRateRangeGroupBulkService = async (data: { agreementRateRangeDtoList: any[] }, productIdValue: number) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${agreementRateRangeMaster}/${bulk}/${productIdValue}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateMasterRateRangeGroupService = async (data: any, id: number) => {
    try {
        return await AjexPortalService.put(`${tmsPricingService}${agreementRateRangeMaster}/${id}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DeleteMasterRateRangeGroupByIdService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${tmsPricingService}${agreementRateRangeMaster}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

// ─── Station Additional Weight Charges (Manual Waybill Default Charges) ───────

export const GetMasterRateRangeStationListByProductService = async (productIdValue: number) => {
    try {
        return await AjexPortalService.get(`${tmsPricingService}${agreementRateRangeStationMaster}/${productId}/${productIdValue}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const SaveMasterRateRangeStationBulkService = async (data: { agreementRateRangeDtoList: any[] }, productIdValue: number) => {
    try {
        return await AjexPortalService.post(`${tmsPricingService}${agreementRateRangeStationMaster}/${bulk}/${productIdValue}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const UpdateMasterRateRangeStationService = async (data: any, id: number) => {
    try {
        return await AjexPortalService.put(`${tmsPricingService}${agreementRateRangeStationMaster}/${id}`, data);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};

export const DeleteMasterRateRangeStationByIdService = async (id: number) => {
    try {
        return await AjexPortalService.delete(`${tmsPricingService}${agreementRateRangeStationMaster}/${id}`);
    } catch (error) {
        const err = error as AxiosError;
        getNotificationStyle(err?.response);
        return err?.response;
    }
};
